import React, { useMemo } from "react";
import Seo from "@/components/common/Seo";
import Breadcrumbs from "@/components/common/Breadcrumbs";
import WalletTabs from "@/components/rewards/WalletTabs";
import EventsLedger from "@/components/rewards/EventsLedger";
import { usePointsBalance } from "@/hooks/usePoints";

/**
 * Iter 629 — dedicated points-history tab (/points/history): the full
 * activity ledger from GET /points/balance, under the shared wallet tabs.
 */
export default function PointsHistoryPage() {
  const pointsQ = usePointsBalance();
  const me = pointsQ.data || {};

  // Same defensive sort as the rewards hub — backend order isn't a contract.
  const events = useMemo(() => {
    const raw = me.events || me.ledger || [];
    return [...raw].sort(
      (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0),
    );
  }, [me.events, me.ledger]);

  return (
    <div className="max-w-2xl mx-auto px-4 md:px-8 py-8 md:py-12">
      <Seo title="Points history" description="Every points action on your AllSale wallet — earns, redemptions, purchases and gifts." />
      <Breadcrumbs items={[{ label: "Rewards", to: "/rewards" }, { label: "History" }]} />
      <div className="mt-6 mb-4">
        <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-900">My Wallet</h1>
      </div>
      <WalletTabs active="history" />
      <div className="mt-5">
        <EventsLedger events={events} />
      </div>
    </div>
  );
}
